import React, { Component } from 'react';
import { connect } from 'react-redux';
import {API_URL} from "../Constants"; // Import API_URL
import ReactGA from 'react-ga';
import defaultAvatar from '../../assets/images/default-avatar.png';
import Modal from 'react-modal';
import { Badge, Button, Card, CardBody, CardHeader, CardImg, CardTitle, Row, Col, ListGroup, ListGroupItem } from 'reactstrap';

class MyTable extends Component {

  constructor() {
    super();
    this.state = {
      data: [],
      profileUrl: null,
      showProfile: false
    };
    ReactGA.event({
      category: 'TeamStanding',
      action: 'Open'
    });    
  }

  componentDidMount () {
    fetch(`${API_URL}/app/api/v1/games/player-score-standing`)
              .then(results => {
                return results.json();
              }).then(resp => {
                // console.log(resp)
                if(resp.message === "Gateway timeout"){

                }else{
                  const top25 = resp.slice(0, 25);
                  this.setState({data: top25});
                }
              });
  }
  viewProfile(profileUrl){
    this.setState(prevState => ({
          data: prevState.data,
          profileUrl: profileUrl,
          showProfile: !prevState.showProfile
      }))
  }

  closeShowProfileModel = () => {
    this.setState(prevState => ({
        ...prevState,
        profileUrl: null,
        showProfile: !prevState.showProfile
    }));
    return null;
  }

  render() {
    return (
      <div className="card">
    <div className="header">
      <h4 className="title">Top (25) Performers</h4>
    </div>
    <div className="content table-responsive table-full-width">
      <table className="table table-hover table-striped">
        <thead>
          <tr>
            <th>Rank</th>
            <th>Player</th>
            <th>Team</th>
            <th>Goals</th>
          </tr>
        </thead>
        <tbody>
          {this.state.data.map(score => (
            <tr key={score.playerid}>
              <td className="custom-td">{score.rank}</td>
              <td className="custom-td">
                <div className="d-flex align-items-center">
                  <div>
                    {score.profilePic && <img role="button" className="rounded-circle" width={50} height={50} src={score.profilePic} onClick={()=> this.viewProfile(score.profilePic)} />}
                    {!score.profilePic && <img role="button" className="rounded-circle" width={50} height={50} src={defaultAvatar} onClick={()=> this.viewProfile(defaultAvatar)}  />}
                  </div>
                  <div className="ms-4">
                    {score.firstName} {score.lastName}
                  </div>
                </div>
              </td>
              {/* <td className="custom-td"></td> */}
              <td className="custom-td">{score.teamName}</td>
              <td className="custom-td">{score.score}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <Modal isOpen={this.state.showProfile} onRequestClose={() => this.playersHandler()} >
        <div>
            <div>
                { this.state.profileUrl && <img width={250} height={350} src={this.state.profileUrl} /> }
                { !this.state.profileUrl && <img width={250} height={350} src={defaultAvatar} /> }
            </div>
            <div>
                <Button color="primary" className="mt-4" onClick={() => this.closeShowProfileModel()}> X Close </Button>
            </div>
        </div>
    </Modal>
    </div>
  </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.Auth.user
});

export default connect(mapStateToProps)(MyTable);


// WEBPACK FOOTER //
// ./src/components/Table/TopPerformersTable.js